<script>
  import { ENTRIES } from "#lib/app_config.js";
  import ButtonLabel from "#lib/ButtonLabel.svelte";
  import Popover from "#lib/Popover.svelte";
  import t from "#lib/i18n.svelte.js"

  let {
    class: css_class,
    site_settings
  } = $props()

  let anchor_ref = $state();
  let popover_ref = $state();
</script>

<button 
  class={css_class}
  bind:this={anchor_ref} 
  popovertarget='create-entry-tool-popover' 
  title={t("new")}
  style='--button-outer-block-spacing: var(--default-button-outer-block-spacing)'
>
  <ButtonLabel variant='brand flush text-compact' start_icon='plus' />
</button>

<Popover
  anchor={anchor_ref}
  id='create-entry-tool-popover'
  bind:ref={popover_ref}
  placement='bottom-end'
  offset={6}
>
  <div class="flex-column">
    {#each Object.entries(ENTRIES) as [entry_type,entry_obj], i}
      <a
        href={`/new/${entry_type === 'image' ? 'media' : entry_type}`}
      >
        <ButtonLabel
          variant='brand ghostly'
          start_icon={entry_obj.icon}
          align='start-stretch'
          text_style='text-control'
        >
          {t(entry_obj.label_i18n)}
        </ButtonLabel>
      </a>
    {/each}
  </div>
</Popover>
